import * as React from 'react';
import { Component } from 'react';
import { ITherapy } from '../../models/ITherapy';
import { SimpleSelectComponent } from '../../controls/SimpleSelect';
import { IDropDownItem } from '../../models/IDropDownItem';
import { TherapyService } from '../../services/TherapyService';
import { LoaderComponent } from '../../controls/Loader';
import { DEFAULT_STATUS_TIMEOUT } from '../../constants/SystemConsts';
import { ShowStatusBar } from '../Layout/GlobalStatusBar';

interface IProps {
    Therapies: ITherapy[],
    AllTherapies: IDropDownItem[],
    OnRefreshRequired: () => void,
    IsEditMode: boolean
}

interface IState {
    ShowAll: boolean,
    ShowAddTherapies: boolean,
    InputValue?: string,
    LoaderVisible: boolean,
    SelectedTherapy?: IDropDownItem
}

export class TherapiesComponent extends Component<IProps, IState> {
    constructor(props) {
        super(props);

        this.state = {
            ShowAll: this.props.IsEditMode,
            ShowAddTherapies: false,
            LoaderVisible: false
        }

        this.ShowMore = this.ShowMore.bind(this);
        this.ShowLess = this.ShowLess.bind(this);
        this.OnTherapySelected = this.OnTherapySelected.bind(this);
        this.OnInputValueChange = this.OnInputValueChange.bind(this);
        this.OnAbort = this.OnAbort.bind(this);
        this.OnSave = this.OnSave.bind(this);
        this.OnAddSuccess = this.OnAddSuccess.bind(this);
        this.OnAddError = this.OnAddError.bind(this);
        this.OnAddNewTherapy = this.OnAddNewTherapy.bind(this);
        this.OnDeleteSuccess = this.OnDeleteSuccess.bind(this);
        this.OnDeleteError = this.OnDeleteError.bind(this);
    }

    public componentWillReceiveProps(nextProps: IProps) {
        this.setState({
            LoaderVisible: false
        });
    }

    public render() {
        let itemsElement: null | JSX.Element = null;
        let buttons: null | JSX.Element = null;
        if (this.props.IsEditMode) {
            buttons = (
                <div className="buttons">
                    <a onClick={this.OnAddNewTherapy}>Dodaj terapię</a>
                </div>
            );
        }
        if (this.state.ShowAddTherapies && this.state.SelectedTherapy !== undefined) {
            buttons = (
                <div className="buttons">
                    <button className="std-secondary-btn" onClick={this.OnAbort}>Anuluj</button>
                    <button className="std-primary-btn" onClick={this.OnSave}>Zapisz</button>
                </div>
            );
        };
        let therapies: null | ITherapy[] = null;
        if (this.state.ShowAll) {
            therapies = this.props.Therapies;
        } else {
            therapies = this.props.Therapies.filter((i, index) => (index < 4));
        }
        let items = therapies.map((therapy) => (
            <li key={therapy.Id}>
                <span>{therapy.Name}</span>&nbsp;
                {
                    this.props.IsEditMode ?
                        (
                            <div>
                                <span className="delete-icon" onClick={this.OnTherapyDelete.bind(this, therapy.Id)} />
                            </div>
                        ) :
                        null
                }
            </li>
        ));
        let showMoreElement: null | JSX.Element = null;
        if (this.props.Therapies.length > 4) {
            if (this.state.ShowAll) {
                showMoreElement = (
                    <li key={0}>
                        <a onClick={this.ShowLess}>zobacz mniej</a>
                    </li>
                );
            } else {
                showMoreElement = (
                    <li key={0}>
                        <a onClick={this.ShowMore}>zobacz więcej</a>
                    </li>
                );
            }
        }
        itemsElement = (
            <div className="input">
                <ul className="therapies-list">
                    <LoaderComponent Visible={this.state.LoaderVisible} />
                    {items}
                    {
                        items.length === 0 ?
                            (<div className="info">
                                <p>
                                    W czym się specjalizujesz?
                                </p>
                            </div>):
                            null
                    }
                    {!this.props.IsEditMode && showMoreElement}
                </ul>
                {
                    this.state.ShowAddTherapies && 
                        <SimpleSelectComponent
                            Items={this.props.AllTherapies}
                            Placeholder="Wybierz terapię"
                            OnItemSelected={this.OnTherapySelected}
                            OnValueChange={this.OnInputValueChange} />
                }
                {buttons}
            </div>
        );
        return (
            <div className="form-row">
                <label>Stosowane terapie:</label>
                {itemsElement}
            </div>
        );
    }

    private ShowMore(evt) {
        this.setState({
            ShowAll: true
        });
    }

    private ShowLess(evt) {
        this.setState({
            ShowAll: false
        });
    }

    private OnTherapySelected(selectedItem: IDropDownItem) {
        //this.setState({
        //    LoaderVisible: true
        //});
        //let service = new TherapyService();
        //service.AddMyTherapy({
        //    TherapyId: selectedItem.Id,
        //    ClinicId: 0
        //}, this.OnAddSuccess, this.OnAddError);
        this.setState({
            SelectedTherapy: selectedItem
        });
    }

    private OnAddSuccess(result) {
        this.props.OnRefreshRequired();
        ShowStatusBar('Success', 'Dodano terapię', DEFAULT_STATUS_TIMEOUT);
    }

    private OnAddError(error) {
        console.error(error);
        this.setState({
            LoaderVisible: false
        });
        ShowStatusBar('Error', 'Nie udało się dodać terapii. Spróbuj ponownie.', DEFAULT_STATUS_TIMEOUT);
    }

    private OnInputValueChange(evt) {
        this.setState({
            InputValue: evt.target.value
        });
    }

    private OnAbort(evt) {
        this.setState({
            ShowAddTherapies: false
        });
    }

    private OnSave(evt) {
        if (this.state.SelectedTherapy !== undefined) {
            this.setState({
                ShowAddTherapies: false,
                LoaderVisible: true
            });
            let service = new TherapyService();
            service.AddMyTherapy({
                TherapyId: this.state.SelectedTherapy.Id,
                ClinicId: 0
            }, this.OnAddSuccess, this.OnAddError);
        } else {
            if (this.state.InputValue) {
                if (this.state.InputValue.length > 0) {
                    this.setState({
                        ShowAddTherapies: false,
                        LoaderVisible: true
                    });
                    let service = new TherapyService();
                    service.AddMyTherapy({
                        TherapyName: this.state.InputValue,
                        ClinicId: 0
                    }, this.OnAddSuccess, this.OnAddError);
                }
            }
        }
    }

    private OnAddNewTherapy(evt) {
        this.setState({
            ShowAddTherapies: true
        });
    }

    private OnTherapyDelete(id: number, evt) {
        this.setState({
            LoaderVisible: true
        });
        let service = new TherapyService();
        service.RemoveMyTherapy(id, this.OnDeleteSuccess, this.OnDeleteError);
    }

    private OnDeleteSuccess(result) {
        this.props.OnRefreshRequired();
        ShowStatusBar('Success', 'Usunięto terapię', DEFAULT_STATUS_TIMEOUT);
    }

    private OnDeleteError(error) {
        console.error(error);
        this.setState({
            LoaderVisible: false
        });
        ShowStatusBar('Error', 'Nie udało się usunąć terpii. Spróbuj ponownie.', DEFAULT_STATUS_TIMEOUT);
    }
}


// WEBPACK FOOTER //
// ./src/components/PhysiotherapistView/Therapies.tsx